import ImageGallery from 'react-image-gallery';
import './index.scss';
import styled from 'styled-components';
import { RenderLeftNav, RenderRightNav } from './components/nav';
import { useMemo } from 'react';
import ReactImageGallery from 'react-image-gallery';
import AutoPlayVideo from 'components/AutoPlayVideo';
import { CarouselItem } from 'services/viewVehicleSlice/viewVehicleSlice';
import GptIcon from 'components/Icons/gpt.svg';

const IconWrapper = styled.span`
  & svg {
    transform: translateY(10px);
  }
`;

type Props = {
  imageGalleryRef: React.RefObject<ReactImageGallery>;
  images: CarouselItem[];
  handleClick?: () => void;
};

export const VehicleImageCarousel = ({ imageGalleryRef, images, handleClick }: Props) => {
  const mappedImages = useMemo(
    () =>
      images.map(i => ({
        original: i.url!,
        thumbnail: i.url_thumb,
        type: i.type,
        description:
          'notes' in i && (i.notes?.message || i.notes?.ai_message) ? (
            <span>
              <IconWrapper style={{ marginRight: '4px', transform: 'translateY(40px)' }}>
                {(i.type?.endsWith('_tire') || i.notes?.status === 'ai_used') && i.notes?.ai_message ? (
                  <GptIcon />
                ) : null}
              </IconWrapper>
              {i.type?.endsWith('_tire') ? i.notes.ai_message || i.notes.message : i.notes.message}
            </span>
          ) : (
            ''
          )
      })),
    [images.length]
  );

  return (
    <ImageGallery
      ref={imageGalleryRef}
      slideDuration={0}
      showPlayButton={false}
      showFullscreenButton={false}
      onClick={handleClick}
      renderLeftNav={(onclick, disabled) => <RenderLeftNav onClick={onclick} disabled={disabled} />}
      renderRightNav={(onclick, disabled) => <RenderRightNav onClick={onclick} disabled={disabled} />}
      renderItem={item => {
        if ((item as any).type === 'exterior.video') {
          return (
            <div className="image-gallery-image" style={{ position: 'relative' }}>
              <AutoPlayVideo src={item.original} disableNativeFullscreen />
              {/* Invisible overlay: blocks clicks from reaching the video (native fullscreen)
                  and opens the fullscreen carousel instead */}
              <div
                style={{ position: 'absolute', inset: 0, zIndex: 1, cursor: 'pointer' }}
                onClick={handleClick}
              />
            </div>
          );
        }
        return (
          <div className="image-gallery-image">
            <img src={item.original} alt="" />
            {item.description && <span className="image-gallery-description">{item.description}</span>}
          </div>
        );
      }}
      items={mappedImages as any[]}
      showIndex
      useBrowserFullscreen={false}
      showThumbnails={false}
      infinite={true}
    />
  );
};
